<template>
  <div class="cf-checkbox-input cf-checkbox-input--default">
    <div class="cf-checkbox-input__options">
      <div class="cf-checkbox-input__option">
        <input
          :id="name"
          v-model="val"
          class="cf-checkbox-input__input"
          type="checkbox"
          :name="name"
          :value="modelValue"
          :disabled="disabled"
        >

        <label
          class="cf-checkbox-input__label"
          :for="name"
        >
          <span class="cf-checkbox-input__label-text">
            <slot />
          </span>
        </label>
      </div>
    </div>

    <cf-input-error :error="errorMessage ? 'This checkbox is required.' : null" />
  </div>
</template>


<script>
  import { watch } from 'vue';
  import { useField } from 'vee-validate';

  import CfInputError from '@/view/components/shared/cf-input-error/index.vue';


  export default {
    name: 'CfCheckboxInput',

    components: {
      CfInputError
    },

    props: {
      disabled: {
        type: Boolean,
        default: false
      },

      name: {
        type: String,
        required: true
      },

      validations: {
        type: Object,
        default() {
          return {};
        }
      },

      modelValue: {
        type: [String, Number, Boolean],
        default: null
      }
    },

    // VeeValidate 4 requires the Composition API to register a field with the parent form context.
    // setup() is used exclusively for that purpose — all other component logic
    // remains in the Options API below.
    // Exposes: errorMessage (reactive validation error string, undefined when valid)
    // Note: handleChange is used internally by the watch() below and is not exposed.
    setup(props) {
      const { errorMessage, handleChange } = useField(() => props.name, () => props.validations, {
        initialValue: props.modelValue
      });

      watch(() => props.modelValue, handleChange);

      return { errorMessage };
    },

    computed: {
      val: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    }
  };
</script>
